import {useComputed} from "@preact/signals-react";
import {isEmpty} from '@ui-seeker/utils'

import {adminProductReviewDetailsClicked, adminProductReviewRawTableData} from "../@signals";

export default function useAdminProductReviewDetails() {
	const detailsData = useComputed(() => {
		if (adminProductReviewRawTableData.value === null)
			return {}
		
		const rowData = adminProductReviewRawTableData.value.filter(item => item.key === adminProductReviewDetailsClicked.value)[0] || []
		return {
			...adminProductReviewRawTableData.value.filter(item => item.key === rowData.key)[0]?.details[0],
            ...rowData
		}
	})

	return {
		showDetails: !isEmpty(detailsData.value),
		detailsData: detailsData.value
	}
}